import React, { useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { BsX } from "react-icons/bs";
import "./modal-generic.css";

const ModalGeneric = props => {
	const lastOpenProps = useRef(props);
	const modalRef = useRef(null);

	useEffect(() => {
		if (!props.open) {
			return;
		}

		lastOpenProps.current = props;

		const dialog = modalRef.current && modalRef.current.dialog;

		if (dialog && document.activeElement === document.body) {
			dialog.focus();
		}
	});

	const {
		id = "modal-generic",
		title,
		subtitle = null,
		icon: Icon,
		closable = true,
		className = "",
		footer,
		children,
		onClose
	} = props.open ? props : lastOpenProps.current;

	return (
		<Modal
			ref={modalRef}
			show={Boolean(props.open)}
			onHide={onClose}
			centered
			backdrop={closable ? true : "static"}
			keyboard={closable}
			dialogClassName={["modal-generic", className].filter(Boolean).join(" ")}
			aria-labelledby={`${id}-title`}
		>
			<div className="modal-generic__header">
				{Icon && <Icon size={18} aria-hidden="true" />}

				<span id={`${id}-title`} className="modal-generic__title">
					{subtitle && (
						<span className="modal-generic__subtitle">
							{subtitle}
						</span>
					)}

					{title}
				</span>

				{closable && (
					<button
						type="button"
						id={`btn-fechar-${id}`}
						className="modal-generic__close"
						aria-label="Fechar"
						onClick={onClose}
					>
						<BsX size={28} aria-hidden="true" />
					</button>
				)}
			</div>

			<div className="modal-generic__body">
				{children}
			</div>

			{footer && (
				<div className="modal-generic__footer">
					{footer}
				</div>
			)}
		</Modal>
	);
};

export default ModalGeneric;
